/**
 * Created by razial on 03.04.2026.
 */

const EditorCommand = function (options) {
    this.uid = options.uid || this.createUUID();
    this.batchId = options.batchId;
    this.userId = options.userId;

    this.redoData = {
        type: options.type,
        data: options.data
    };
    this.undoData = undefined;

    this.handler = EditorClient.COMMANDS.get(options.type);
};

EditorCommand.prototype.createUUID = function () {
    return Date.now().toString(36).padStart(9, "0") + Math.random().toString(36).slice(2, 8).padEnd(6, "0");
};

EditorCommand.prototype.getInfo = function () {
    return {
        uid: this.uid,
        userId: this.userId,
        type: this.redoData.type,
        data: this.redoData.data
    };
};

EditorCommand.prototype.execute = function (editor) {
    const data = this.handler.execute(editor, this.redoData.data);
    if (!data) {
        return false;
    }

    this.undoData = data;

    return true;
};
